import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import Util from '../../helper/Util';
import { Translate } from '../../localization';
import { Link } from 'react-router-dom';
import Login from '../Login';
import SignUp from '../SignUp';
import { isEmpty } from 'lodash';
import { getDeviceLocation, setLanguage } from '../../store/actions/general.actions';
import { setLocationsActive, setPrematchActive } from '../../store/actions/prematchActions';
import { getCashbackData } from '../../store/actions/user.actions';
import MenuBar from './MenuBar';
import { META_LOGIN_TIME } from '../../config';

const options = ['en', 'zh(CN)', 'zh(TW)', 'th'];
let metaInterval;
class Header extends Component {
    constructor(props) {
        super(props);

        this.header = React.createRef();

        this.state = {
            anchorEl: null,
            selectedIndex: 0,
            showLogin: false,
            showSignUp: false,
            cashbackAvailable: false,
            theme: '',
            showMobileSidebar: false,
            metaMaskAccount: localStorage.getItem('accounts') ? Util.cryptoJsDecryption(localStorage.getItem('accounts')) : [],
            metaLoginTime: localStorage.getItem('metaLoginTime') ? JSON.parse(localStorage.getItem('metaLoginTime')) : '',
            metaMaskBalance: null,
        };
    }

    componentDidMount() {
        let userSelectedLang = this.props.language;
        let userSelectedLangIndex = options.indexOf(userSelectedLang);

        this.props.getDeviceLocation();
        this.checkMetaLogin();

        if (userSelectedLangIndex !== this.state.selectedIndex) {

            Translate.setLanguage(userSelectedLang);
            this.setState({
                selectedIndex: userSelectedLangIndex,
            });
        }

        if (!isEmpty(this.props.cashbackData)) {
            this.setState({ cashbackAvailable: this.props.cashbackData.is_cashback_available });
        }

        window.addEventListener('scroll', this.toggleHeader, false);
        if (!localStorage.getItem('theme')) {
            document.body.classList.remove('dark-mode');
            localStorage.setItem('theme', 'light-mode');
            this.setState({ theme: 'light-mode' });
        }
        else if (localStorage.getItem('theme') && localStorage.getItem('theme') === 'dark-mode') {
            document.body.classList.add('dark-mode');
            this.setState({ theme: 'dark-mode' });
        }
    }

    componentDidUpdate(prevProps) {
        let { userData, cashbackData } = this.props;

        if (prevProps.country !== this.props.country && (this.props.country === 'NL' || this.props.country === 'DE') && !localStorage.getItem('language')) {
            let lang = this.props.country === 'NL' ? 'nl' : 'de';
            Translate.setLanguage(lang);
            let userSelectedLangIndex = options.indexOf(lang);
            this.changeLanguage(null, userSelectedLangIndex);
            this.setState({
                selectedIndex: userSelectedLangIndex,
            });
        }

        if (prevProps.userData !== userData && userData) {
            // getCashbackData();
        }

        if (prevProps.cashbackData !== cashbackData && !isEmpty(cashbackData)) {
            this.setState({ cashbackAvailable: this.props.cashbackData.is_cashback_available });
        }

        if (localStorage.getItem('agentCode') && !this.state.showSignUp && !this.isLoggedIn() && localStorage.getItem('firstAgentCodeHit') === 'true') {
            this.showSignUpForm();
            localStorage.setItem('firstAgentCodeHit', false); //To allow closing of signup form
        }
    }

    componentWillUnmount() {
        this.header.current.classList.remove('header_dark');
        window.removeEventListener('scroll', this.toggleHeader, false);
    }

    toggleHeader = () => {
        if (this.props.headerClassname === 'header_transparent') {
            if (window.pageYOffset > this.header.current.clientHeight) {
                this.header.current.classList.add('header_dark');
            } else {
                this.header.current.classList.remove('header_dark');
            }
        }
    };

    goToPage = (path) => {
        this.props.history.push(path);
    };

    onGoBack = () => {
        if (this.props.location.pathname === '/sports' && !this.props.isLocationsActive) {
            this.props.setLocationsActive(true);
            this.props.setPrematchActive(false);
        }
        else this.props.history.goBack();
    };

    handleClickMenu = (event) => {
        this.setState({
            anchorEl: event.currentTarget,
        });
    };

    // changeLanguage = (event, index) => {
    //     let language = options[index];
    //     // FIXME: For the temp work we will be sending fr as code for Portuguese language (pt)
    //     //if  (language === 'pt') language = 'fr';
    //     Translate.setLanguage(language);
    //     this.props.setLanguage(Translate.getLanguage());
    //     localStorage.setItem('language', language);

    //     this.setState({
    //         anchorEl: null,
    //         selectedIndex: index,
    //     });
    // };

    changeLanguageMobile = (event) => {
        let index = parseInt(event.target.value);
        let language = options[index];
        // FIXME: For the temp work we will be sending fr as code for Portuguese language "pt"
        //if  (language === 'pt') language = 'fr';
        Translate.setLanguage(language);
        this.props.setLanguage(Translate.getLanguage());
        localStorage.setItem('language', language);

        this.setState({
            selectedIndex: index,
        });
    };

    handleCloseMenu = () => {
        this.setState({
            anchorEl: null,
        });
    };

    showLoginForm = (e) => {
        this.setState({ showLogin: true });
    };

    hideLogin = () => {
        this.setState({ showLogin: false });
    };

    showSignUpForm = (e) => {
        this.setState({ showSignUp: true });
    };

    hideSignUp = () => {
        this.setState({ showSignUp: false });
    };

    isLoggedIn = () => {
        const { access_token } = Util.getAccessToken();
        const isUserLoggedIn = Util.isAuthTokenValid(access_token);
        return isUserLoggedIn;
    };
    handleToggle = () => {
        if (localStorage.getItem('theme') && localStorage.getItem('theme') === 'dark-mode') {
            localStorage.setItem('theme', 'light-mode');
            document.body.classList.remove('dark-mode');
            this.setState({ theme: 'light-mode' });
        }
        else if (localStorage.getItem('theme') && localStorage.getItem('theme') === 'light-mode') {
            localStorage.setItem('theme', 'dark-mode');
            document.body.classList.add('dark-mode');
            this.setState({ theme: 'dark-mode' });
        } else {
            localStorage.setItem('theme', 'light-mode');
            document.body.classList.remove('dark-mode');
            this.setState({ theme: 'light-mode' });
        }
    }

    reqMetaMaskAccount = async () => {
        // MetaMask will inject ethereum object in webpage.
        const { ethereum } = window;
        if (!ethereum) { // in case ethereum is not available
            toastr.error('', 'Please install the metaMask extension and refresh the page.');
            setTimeout(() => {
                window.open('https://metamask.io/');
            }, 2000);
        } else { // ethereum is available
            try {
                const accounts = await ethereum.request({ method: 'eth_requestAccounts' }); // will get all accounts
                if (accounts.length > 0) {
                    let params = [accounts[0], 'latest']; // params for get balance
                    let balance = await ethereum.request({ method: 'eth_getBalance', params });
                    let EthBal = parseInt(balance, 16);
                    EthBal = EthBal * Math.pow(10, (-18));
                    const encryptedAccount = Util.cryptoJsEncryption(accounts)
                    this.setState({ metaMaskAccount: accounts, metaMaskBalance: EthBal });
                    localStorage.setItem('accounts', encryptedAccount)
                    localStorage.setItem('metaLoginTime', JSON.stringify(new Date().getTime()))
                    metaInterval = setInterval(() => {
                        this.checkMetaLogin(true);
                    }, META_LOGIN_TIME + 500);
                } else {
                    toastr.error('', 'Request denied, please try again');
                }
            } catch (err) {
                toastr.error('', err?.message);
            }
        }
    }

    checkMetaLogin = (sessionExpired) => {
        const { metaMaskAccount, metaLoginTime } = this.state;
        const { ethereum } = window;
        if (metaMaskAccount?.length && (metaLoginTime + META_LOGIN_TIME) > new Date().getTime()) {
            try {
                let params = [metaMaskAccount[0], 'latest']; // params for get balance
                ethereum.request({ method: 'eth_getBalance', params }).then((balance) => {
                    let EthBal = parseInt(balance, 16);
                    EthBal = EthBal * Math.pow(10, (-18));
                    this.setState({ metaMaskBalance: EthBal });
                });
            } catch (err) {
                this.signOutMetaMask(false);
            }
        } else {
            this.signOutMetaMask(false, sessionExpired);
        }
    }

    signOutMetaMask = async (showSuccess = true, sessionExpired = false) => {
        // localStorage.setItem('metaMaskLoggedIn', false)
        // const { ethereum } = window;
        // const accounts = await ethereum.request({ method: 'disconnect'})
        if (showSuccess) toastr.success('', 'Sign out successfully');
        else if (sessionExpired) toastr.error('', 'Session expired please login again.');
        localStorage.removeItem('accounts');
        localStorage.removeItem('metaLoginTime');
        this.setState({ metaMaskAccount: [], metaMaskBalance: null, metaLoginTime: '' });
        clearInterval(metaInterval);
    }


    render() {
        let { anchorEl, selectedIndex, showLogin, showSignUp, cashbackAvailable, showMobileSidebar, metaMaskBalance } = this.state;
        let { userData, location, headerClassname } = this.props;
        let currency = userData && userData.currency ? userData.currency === 'EUR' ? 'USD' : userData.currency : 'USD';
        let showBackBtn = location.pathname.split('/').length > 2 && ['casino', 'live-casino'].indexOf(location.pathname.split('/')[1]) < 0 ? true : false;
        let pageTitle = this.props.pageTitle;
        let isMetaMask = metaMaskBalance != null;

        // const languageList = options.map((option, index) => (
        //     <MenuItem key={option} selected={index === selectedIndex} onClick={(event) => this.changeLanguage(event, index)} className="text-uppercase">
        //         {option}
        //     </MenuItem>
        // ));

        const languageListMobile = options.map((option, index) => (
            <option key={option} value={index} className="text-uppercase">
                {option.toUpperCase()}
            </option>
        ));

        let isNotHome = false;
        if (location.pathname !== '/') {
            isNotHome = true;
        }

        return (
            <div className={`container header_fix d-flex align-items-center justify-content-between  mui-fixed ${headerClassname}`} ref={this.header}>
                <div className="d-flex align-items-center">
                    {showBackBtn ? (
                        <button className="header__back-btn btn-icon text-white p-1" onClick={this.onGoBack}>
                            <i className="material-icons text-white"> keyboard_arrow_left </i>
                        </button>
                    ) : (
                        <div className='d-flex align-items-center'>
                            <div className='mob-toggler-icon-wrap' onClick={() => this.setState({ showMobileSidebar: true })}>
                                <img src='/images/sports/menu.png' className="mob-toggler-icon" alt="Menu-icon" />
                            </div>
                            <span className="text-white  disable-select header__logo-wrap" onClick={(e) => this.goToPage('/')}>
                                <img src="/images/sports/logo.png" alt="Logo" />
                            </span>
                        </div>
                    )
                    }
                    {
                        isNotHome && (
                            <div>
                                {/* <span onClick={(e) => this.goToPage('/')}>
                                    <img src="/images/logo-mark.png" style={{ paddingTop: "5px", width: '20px', paddingRight: '5px'}}/>
                                </span> */}
                            </div>
                        )
                    }

                    {/* {showBackBtn ?  (
                        (pageTitle && pageTitle === 'casino') ? 
                            null : (
                                <button className="header__back-btn btn-icon text-white p-1" onClick={this.onGoBack}>
                                    <i className="material-icons text-white"> keyboard_arrow_left </i>
                                </button>
                            )
                        ) : null
                    } */}
                    {/* {(pageTitle && pageTitle !== 'casino') ? (
                        <p className="header__title my-0">{Translate[pageTitle]}</p>
                    ) : (
                        <span className="text-white  disable-select header__logo-wrap" onClick={(e) => this.goToPage('/')}>
                            <img src="./images/sports/logo.png" alt="Logo" />
                            
                        </span>
                    )} */}
                </div>
                <div className="fs-22 d-flex align-items-center justify-content-end">
                    {/* <div className="language-select">
                        <span
                            aria-haspopup="true"
                            aria-controls="language-menu"
                            className="language-select__selected text-uppercase"
                            onClick={this.handleClickMenu}
                        >
                            {options[selectedIndex]}
                        </span>

                        <Menu
                            id="language-menu"
                            className="language-select__menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={this.handleCloseMenu}
                        >
                            {languageList}
                        </Menu>
                    </div> */}
                    {/* <label for='time' class="mb-0 mr-2">
                        <input className='toggle-checkbox' type='checkbox' checked={ this.state.theme === 'dark-mode' } id='time' onClick={ this.handleToggle }></input>
                        <div className='toggle-slot'>
                            <div className='toggle-button'></div>
                        </div>
                    </label> */}
                    {this.isLoggedIn() || isMetaMask ? (
                        <Link className={`${!isMetaMask && 'header__balance'}`} to="/my-account">
                            {isMetaMask ?
                                <>
                                    <button className="btn-in-header p-1"><span>{Translate.walletBalance}: {metaMaskBalance} </span></button>
                                    <button className="btn-in-header p-1" onClick={this.signOutMetaMask}>
                                        {Translate.logout}
                                    </button>
                                </>
                                :
                                <>
                                    <span>{userData ? `${Util.toFixedDecimal(userData.balance)}` : 'Loading...'}</span>
                                    <br />
                                    <span className="currency-text">{currency}</span>
                                </>
                            }
                        </Link>
                    ) : (
                        <Fragment>
                            {/* <button className="btn btn-secondary mr-1 py-1 px-2" onClick={this.reqMetaMaskAccount}>
                                {Translate.metaMaskLogin}
                                <span><img src='/images/metamask-icon.png' alt='metamask' /></span>
                            </button> */}
                            <button className="btn btn-secondary mr-1  py-1 px-2" onClick={this.showLoginForm}>
                                {Translate.login}
                            </button>
                            <button className="btn-in-header p-1" onClick={this.showSignUpForm}>
                                {Translate.signup}
                            </button>
                        </Fragment>
                    )}

                    <div className="language-drop">
                        <select className="language-select_mobile text-uppercase" value={selectedIndex} onChange={this.changeLanguageMobile}>
                            {languageListMobile}
                        </select>
                        <div>
                            <img src="/images/bottom-arrow.svg" />
                        </div>
                    </div>
                </div>
                {showMobileSidebar &&
                    <MenuBar
                        hideMenuBar={() => this.setState({ showMobileSidebar: false })}
                        showMobileSidebar={showMobileSidebar}
                        showLoginForm={this.showLoginForm}
                        showSignUpForm={this.showSignUpForm}
                        history={this.props.history}
                        isLoggedIn={this.isLoggedIn()}
                    />
                }
                {showLogin && <Login hideLogin={this.hideLogin} />}
                {showSignUp && <SignUp hideSignUp={this.hideSignUp} />}
            </div>
        );
    }
}

Header.propTypes = {
    userData: PropTypes.object,
    setLanguage: PropTypes.func,
    language: PropTypes.string,
    headerClassname: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        userData: state.user.data,
        language: state.general.language,
        isLocationsActive: state.prematch.isLocationsActive,
        country: state.general.country,
        cashbackData: state.user.cashbackData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setLanguage: (value) => dispatch(setLanguage(value)),
        setLocationsActive: (value) => dispatch(setLocationsActive(value)),
        setPrematchActive: (value) => dispatch(setPrematchActive(value)),
        getDeviceLocation: () => dispatch(getDeviceLocation()),
        getCashbackData: () => dispatch(getCashbackData()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
